import React, { useEffect, useState } from 'react'
import Header from '../header/header'
import { SummaryCard } from '../../components/SummaryCard'
import Allocation from "../portfolio/interface/Allocation"
import { useDispatch, useSelector } from 'react-redux'
import { getDashboard } from '../../redux/dashboard/dashboard'
import { getDashboardService } from '../../api/dashboard'
import ModalPortfolio from "../modalPortfolio/interface/mPortfolio"

function Index() {
    const dispatch = useDispatch();
    const userDetail = useSelector(state => state.auth.userDetail)
    // const Data = useSelector(state => state.dashboard.data)
    const [DashboardData, setDashboardData] = useState(null)
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await getDashboardService();
                setDashboardData(response.data)
            } catch (error) {
                console.error("Error while fetching the dashboard details ", error);
            } finally {
                setIsLoading(false); // API done
            }
        }
        fetchData();
    }, [])

    const formatPercent = (percent) => `${Number(percent).toFixed(2)}%`;
    return (
        <div>
            {isLoading ? (
                <div>Loading...</div> // or your skeleton loader
            ) : (DashboardData ?
                <>
                    <Header />
                    {(DashboardData?.userDetail?.portfolioAmt) ?
                        <section className="text-body-emphasis bg-body-tertiary">
                            <div className="container py-5">
                                <div className="row g-3 justify-content-center">
                                    {/* Investment Summary */}
                                    <div className="col-md-10">
                                        <div className="border p-3 rounded-3 shadow-sm bg-body shine-effect w-100">
                                            <h1 className="fs-4 fw-bold">
                                                Hello {userDetail?.firstName ?? ''} {userDetail?.lastName ?? ''},
                                            </h1>
                                            {/* <span
                                                style={{
                                                    background: 'linear-gradient(to right, #C609FA, #3959FE, #0E9EEE)',
                                                    WebkitBackgroundClip: 'text',
                                                    WebkitTextFillColor: 'transparent',
                                                    display: 'inline-block',
                                                }}
                                            >
                                                Welcome to Your Portfolio
                                            </span> */}
                                            <div className="d-flex align-items-baseline">
                                                <p className=" mb-0" style={{
                                                    background: 'linear-gradient(to right, #C609FA, #3959FE, #0E9EEE)',
                                                    WebkitBackgroundClip: 'text',
                                                    WebkitTextFillColor: 'transparent',
                                                    display: 'inline-block',
                                                }}>Your Investment Summary</p>
                                            </div>
                                            <small className="text-muted">
                                                As on {new Date().toLocaleDateString('en-GB', {
                                                    day: '2-digit',
                                                    month: 'long',
                                                    year: 'numeric',
                                                })}
                                            </small>
                                            <hr />
                                            <div className="row g-3">


                                                {[
                                                    { label: "Allocated Fund", value: DashboardData?.portfolio?.investedAmount?.toFixed(2) },
                                                    { label: "Available Funds", value: DashboardData?.portfolio?.availableFunds?.toFixed(2) },
                                                    { label: "Invested", value: DashboardData?.invested?.toFixed(2) },
                                                    { label: "Current Value", value: DashboardData?.currentValue?.toFixed(2) },

                                                    {
                                                        label: "Overall P&L",
                                                        value: DashboardData?.overallPLAmt,
                                                        percent: `${DashboardData?.overallPLPer || 0.00}%`,
                                                    },
                                                    {
                                                        label: "Day's P&L ",
                                                        value: DashboardData?.daysPLAmt,
                                                        percent: `${DashboardData?.daysPLPer || 0.00}%`,
                                                    },
                                                ].map((item, index) => {
                                                    const formattedValue =
                                                        item.value != null ? Number(item.value).toLocaleString('en-IN') : '--';
                                                    const percentValue = parseFloat(item?.percent?.replace('%', ''));
                                                    return (
                                                        <div key={index} className="col-lg-3 col-md-3 col-6">
                                                            <div>
                                                                <small className="text-muted">{item.label}</small>
                                                                {item.percent ? (
                                                                    <div className="d-flex align-items-baseline">
                                                                        <h6 className={`text-${Number(item.value) > 0 ? "green" : "red"} mb-0`}>{formattedValue}</h6>
                                                                        <small className={`text-${percentValue > 0 ? "green" : "red"} ms-2`}>
                                                                            {item.percent}
                                                                        </small>
                                                                    </div>
                                                                ) : (
                                                                    <h6 className="mb-0">{formattedValue}</h6>
                                                                )}
                                                            </div>
                                                        </div>
                                                    );
                                                })}

                                            </div>

                                        </div>
                                    </div>
                                    <div className='text-center'>
                                        <button
                                            className="btn btn-primary"
                                            onClick={() => {
                                                window.location.href = "/portfolio"
                                            }}
                                        >
                                            Show Portfolio
                                        </button>
                                    </div>
                                    {/* My Portfolio */}
                                    <div className="col-md-5 d-none">
                                        <SummaryCard
                                            title="🛍️ My Portfolio"
                                            values={{
                                                fund: DashboardData?.portfolio?.availableFunds,
                                                invested: DashboardData?.portfolio?.invested,
                                                investment: DashboardData?.portfolio?.investedAmount,
                                                current: DashboardData?.portfolio?.currentValue,
                                                dayPL: { value: DashboardData?.portfolio?.daysPLAmt, percent: DashboardData?.portfolio?.daysPLPer },
                                                overallPL: { value: DashboardData?.portfolio?.overallPLAmt, percent: DashboardData?.portfolio?.overallPLPer },
                                            }}
                                            path="/portfolio"
                                        />
                                    </div>

                                    {/* My Multibaggers */}
                                    {/* <div className="col-md-5">
                                <SummaryCard
                                    title="🚀 My Multibaggers"
                                    values={{
                                        invested: DashboardData?.multibagger?.invested,
                                        current: DashboardData?.multibagger?.currentValue,
                                        dayPL: { value: DashboardData?.multibagger?.daysPLAmt, percent: DashboardData?.multibagger?.daysPLPer },
                                        overallPL: { value: DashboardData?.multibagger?.overallPLAmt, percent: DashboardData?.multibagger?.overallPLPer },
                                    }}
                                    path="/multibagger"
                                />
                            </div> */}
                                </div>
                            </div>
                        </section> : <Allocation />}
                </>
                :
                <>
                    {/*sticky show rpf check modal start*/}
                    {/* <Header /> */}
                    <ModalPortfolio />

                    {/* <div
                        className={`modal d-none fade ${!DashboardData ? "show d-block" : ""}`}
                        tabIndex="-1"
                        role="dialog"
                        style={{
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            backdropFilter: "blur(2px)",
                        }}
                    >
                        <div
                            className="modal-dialog modal-dialog-centered modal-md"
                            role="document"
                            style={{ pointerEvents: "none" }} // prevent closing outside
                        >
                            <div className="modal-content" style={{ pointerEvents: "auto" }}>
                                <div className="modal-body text-center">
                                    <h4 className="mb-1 fw-semibold">
                                        Premium Service Locked
                                    </h4>

                                    <small className="text-muted mb-3 d-block">
                                        This service is exclusive for active members.<br />
                                        You’re just one step away from unlocking it 🚀
                                    </small>

                                    <div className="d-flex flex-column align-items-center gap-2 mt-3">
                                        <button
                                            className="btn btn-primary"
                                            onClick={() => {
                                                window.open("https://equitypandit.in/portfolio", "_blank");
                                            }}
                                        >
                                            Click here to activate your access
                                        </button>

                                        <button
                                            className="btn btn-dark w-50 d-none"
                                            onClick={() => {
                                                window.open("https://equitypandit.in/portfolio", "_blank");
                                            }}
                                        >
                                            Logout
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div> */}

                    {/* Prevent page scroll when modal is active */}
                    {/* {!DashboardData && <style>{"body { overflow: hidden; }"}</style>} */}
                    {/*sticky show rpf check modal end*/}
                </>
            )}

        </div>
    )
}

export default Index



